import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import * as M from '@core/api/models';

import { SelectOption } from '@shared/components/form/form-wizard/models/form-wizard.models';

import { InvestmentApiClient } from './investment-api.client';
import {
  buildInvestmentCompanySwitchRequest,
  InvestmentCompanySwitchOption,
  mapCompaniesToFormOptions,
  mapCompaniesToSwitchOptions,
  resolveOptionalCompanyId,
} from '@features/investment/utils/investment-company.utils';

@Injectable({ providedIn: 'root' })
export class InvestmentCompanyBindingService {
  private readonly investmentApi = inject(InvestmentApiClient);

  async loadCompanyFormOptions(): Promise<SelectOption[]> {
    const companies = await firstValueFrom(this.investmentApi.getCompanies());
    return mapCompaniesToFormOptions(companies ?? []);
  }

  async loadCompanySwitchOptions(): Promise<InvestmentCompanySwitchOption[]> {
    const companies = await firstValueFrom(this.investmentApi.getCompanies());
    return mapCompaniesToSwitchOptions(companies ?? []);
  }

  async loadDeveloperMainCompanyId(): Promise<number | null> {
    const developer = await firstValueFrom(this.investmentApi.getDeveloper());
    return resolveOptionalCompanyId(developer?.company?.id);
  }

  async switchInvestmentCompany(
    investment: M.InvestmentDetailsWithCountsDto,
    companyId: number
  ): Promise<void> {
    const request = buildInvestmentCompanySwitchRequest(investment, companyId);
    await firstValueFrom(this.investmentApi.updateInvestment(investment.id, request));
  }
}
